import { gql } from "@apollo/client";

export const CreateGridItem = gql`
    mutation CreateGridItem ($gridId: ID!){
        createGridItem(gridId: $gridId) {
            id
        }
    }
`;
